import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ReactDOM from 'react-dom/client';
import { AppRoot } from './AppRoot';
var container = document.getElementById('root');
var root = ReactDOM.createRoot(container);
root.render(_jsx(React.StrictMode, { children: _jsx(AppRoot, {}) }));
